import {
  IS_REQUIRED,
  TIME_IS_REQUIRED,
  DRIVER_FORM_ENTITIES,
  INVALID_SHORT_TIME_FORMAT,
} from "../../constants/strings";
import {
  HHMM_TIME_FORMAT,
  getDiffInMinutes,
  isInvalidStopTime,
} from "../../utils/date";

export const validateDriverForm = ({
  driverName,
  dutyStartTime,
  dutyEndTime,
  plannedDepartTime,
  plannedReturnTime,
  collectionStopTime,
  deliveryStopTime,
  vehicleTypeCode,
  sectionCode,
}) => {
  const {
    DUTY_START,
    DUTY_END,
    DEPART,
    RETURN,
    DELIVERY_STOP,
    COLLECTION_STOP,
    DRIVER_NAME,
    VEHICLE_TYPE,
    SECTION,
  } = DRIVER_FORM_ENTITIES;

  const errorTimeRequired = (field) => `${field} ${TIME_IS_REQUIRED}`;

  const errorFieldIsRequired = (field) => `${field} ${IS_REQUIRED}`;

  const errors = {};
  if (!driverName.trim()) {
    errors.driverName = errorFieldIsRequired(DRIVER_NAME);
  } else if (driverName.length > 50) {
    errors.driverName = "Driver's name should be less than 50 characters";
  }

  if (!dutyStartTime) {
    errors.dutyStartTime = errorTimeRequired(DUTY_START);
  } else if (!HHMM_TIME_FORMAT.test(dutyStartTime)) {
    errors.dutyStartTime = INVALID_SHORT_TIME_FORMAT;
  } else if (getDiffInMinutes(dutyEndTime, dutyStartTime) > 690) {
    errors.dutyStartTime = "Duty time cannot exceed 11.5 hours";
  } else if (getDiffInMinutes(dutyStartTime, dutyEndTime) >= 0) {
    errors.dutyStartTime = "Duty start must be before duty end";
  } else if (getDiffInMinutes(dutyStartTime, plannedDepartTime) >= 0) {
    errors.dutyStartTime = "Duty start must be before depart time";
  } else if (getDiffInMinutes(dutyStartTime, plannedReturnTime) >= 0) {
    errors.dutyStartTime = "Duty start must be before return time";
  }

  if (!dutyEndTime) {
    errors.dutyEndTime = errorTimeRequired(DUTY_END);
  } else if (!HHMM_TIME_FORMAT.test(dutyEndTime)) {
    errors.dutyEndTime = INVALID_SHORT_TIME_FORMAT;
  } else if (getDiffInMinutes(dutyStartTime, dutyEndTime) >= 0) {
    errors.dutyEndTime = "Duty end must be after duty start";
  } else if (getDiffInMinutes(plannedDepartTime, dutyEndTime) >= 0) {
    errors.dutyEndTime = "Duty end must be after depart time";
  } else if (getDiffInMinutes(plannedReturnTime, dutyEndTime) >= 0) {
    errors.dutyEndTime = "Duty end must be after return time";
  }

  if (!plannedDepartTime) {
    errors.plannedDepartTime = errorTimeRequired(DEPART);
  } else if (!HHMM_TIME_FORMAT.test(plannedDepartTime)) {
    errors.plannedDepartTime = INVALID_SHORT_TIME_FORMAT;
  } else if (getDiffInMinutes(dutyStartTime, plannedDepartTime) >= 0) {
    errors.plannedDepartTime = "Depart time must be after duty start";
  } else if (getDiffInMinutes(plannedDepartTime, plannedReturnTime) >= 0) {
    errors.plannedDepartTime = "Depart time must be before return time";
  } else if (getDiffInMinutes(plannedDepartTime, dutyEndTime) >= 0) {
    errors.plannedDepartTime = "Depart time must be before duty end time";
  }

  if (!plannedReturnTime) {
    errors.plannedReturnTime = errorTimeRequired(RETURN);
  } else if (!HHMM_TIME_FORMAT.test(plannedReturnTime)) {
    errors.plannedReturnTime = INVALID_SHORT_TIME_FORMAT;
  } else if (getDiffInMinutes(dutyStartTime, plannedReturnTime) >= 0) {
    errors.plannedReturnTime = "Return time must be after duty start";
  } else if (getDiffInMinutes(plannedDepartTime, plannedReturnTime) >= 0) {
    errors.plannedReturnTime = "Return time must be after depart time";
  } else if (getDiffInMinutes(plannedReturnTime, dutyEndTime) >= 0) {
    errors.plannedReturnTime = "Return time must be before duty end time";
  }

  if (!deliveryStopTime) {
    errors.deliveryStopTime = errorTimeRequired(DELIVERY_STOP);
  } else if (isInvalidStopTime(deliveryStopTime)) {
    errors.deliveryStopTime = INVALID_SHORT_TIME_FORMAT;
  }

  if (!collectionStopTime) {
    errors.collectionStopTime = errorTimeRequired(COLLECTION_STOP);
  } else if (isInvalidStopTime(collectionStopTime)) {
    errors.collectionStopTime = INVALID_SHORT_TIME_FORMAT;
  }

  if (!vehicleTypeCode) {
    errors.vehicleTypeCode = errorFieldIsRequired(VEHICLE_TYPE);
  }

  if (!sectionCode) {
    errors.sectionCode = errorFieldIsRequired(SECTION);
  }

  return errors;
};
